import { FundSearchWithDefaultModel } from '@alcon-db-models/FundSearchWithDefaultModel';
import { ChannelForDropdownModel } from '@alcon-db-models/ChannelForDropdownModel';
import { ChannelForDropdownService } from '@services/channel-for-dropdown.service';
import { Store } from '@ngrx/store';
import { Component, HostListener, Input, OnDestroy, OnInit, Optional, ViewChild, Injectable, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { NgModel, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { GridDataResult, SelectionEvent } from '@progress/kendo-angular-grid';
import { CommitmentFormBaseService } from '@services/commitment-form-base.service';
import { WizardFeatureService } from '@services/wizard-feature.service';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import { WindowMode } from '../components.module';
import { FundAdjustment } from '../core/core.module';
import { SelectComponentBase } from '../select.component.base';
import { FundSelectSearchBindingDirective } from './../../directives/fund-select-search-binding.directive';
import { ConfigService } from '@services/config.service';

@Component({
  selector: 'acb-alcon-select-fund',
  template: `
    <kendo-dialog-titlebar class="acb-select-titlebar" (close)="onClose()" *ngIf="windowMode == 'dialog'">
    Select Fund
    </kendo-dialog-titlebar>
    <div fxLayout="column" style="height: 100%;">
      <form [formGroup]="searchForm" style="width: 100%;" class="k-form">
        <acb-alcon-section-with-legend [doShowLegend]="windowMode == 'page'" class="acb-section-03" [sectionTitle]="'Select Fund'">
          <div fxLayout="row wrap" fxLayoutGap="2em" fxLayoutAlign="start start">
            <kendo-formfield fxFlex >
              <kendo-label [for]="fundNameOrYear" text="Fund Name or Year"></kendo-label>
              <input formControlName="fundNameOrYear" kendoTextBox #fundNameOrYear autocomplete="off" />
              <kendo-formhint>&nbsp;</kendo-formhint>
            </kendo-formfield>
            <div fxFlex='0 0 6em' style="text-align: right; padding: 36px 0 0 0;" class="acb-search-button-wrapper">
              <button type="submit" kendoButton (click)="onSearch()" style="width:100%">Search</button>
            </div>
          </div>
        </acb-alcon-section-with-legend>
      </form>

      <div fxLayout="row" fxLayoutGap="2em" fxLayoutAlign="start center" [hidden]=true>
        <kendo-formfield style="display:none" >
          <kendo-label text="Channel"  style="display: block; margin-bottom: 0.5em !important;"></kendo-label>
          <kendo-dropdownlist
            [data]="channels"
            textField="channelName"
            valueField="channelName"
            [valuePrimitive]="true"
            (valueChange)="onGlobalChannelChange($event)"
            [(ngModel)]="selectedChannelName">
          </kendo-dropdownlist>
        </kendo-formfield>
      </div>
      
      <kendo-grid
        fundSelectSearchBinding
        [height]="400"       
        [doInitResults]= "true"
        [selectable] = "{
          enabled: true,
          mode: 'single'
        }"
        [pageSize]="windowMode == 'dialog' ? windowHeigth > 800 ? 10 : 5 : 5"
        [pageable]="{
          buttonCount: 3,
          pageSizes: true,
          responsive: false,
          info: false
        }"
        [sortable]="true"
        [resizable]="true"
        (beforeBind)="updateFilter()"
        kendoGridSelectBy="fundID"
        [(selectedKeys)] = "selectedKeys"  
        (selectionChange)="onSelectionChange($event)"  
        #resultsGrid
        fxFlex
        [ngClass]="{
          'acb-grid-has-selection': !!getSelectedItem(),
          'acb-grid-window-mode-page': windowMode == 'page',
          'acb-grid-window-mode-dialog': windowMode == 'dialog',
          'acb-grid-page-size-5': resultsGrid.pageSize == 5,
          'acb-grid-page-size-10': resultsGrid.pageSize == 10,
          'acb-grid-page-size-15': resultsGrid.pageSize == 15
        }" >
        <kendo-grid-command-column [width]="32" [locked]="true" >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" *ngIf="true">        
        <input
          type="checkbox"
          kendoCheckBox
          [checked]="selectedKeys.includes(dataItem.fundID)"
          (change)="onCheckboxChange($event, dataItem, rowIndex)">
        </ng-template>       
        </kendo-grid-command-column>
                
        <kendo-grid-column title="Name" field="displayName" [width]="240"></kendo-grid-column>

        <kendo-grid-column title="Year" field="year" [width]="100"></kendo-grid-column>

        <kendo-grid-column title="Budget" field="budget" format="{0:c}" class="acb-grid-column-currency" [width]="110" *ngIf="showAdjustments">
        </kendo-grid-column>
        <kendo-grid-column title="Allocations" field="allocations" format="{0:c}" class="acb-grid-column-currency" [width]="110" *ngIf="showAdjustments">
        </kendo-grid-column>
        <kendo-grid-column title="Adjustments" class="acb-grid-column-currency" [width]="110" *ngIf="fundAdjustments?.length && showAdjustments">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ getFundAdjustment(dataItem) | currency }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Balance" class="acb-grid-column-currency" [width]="75" *ngIf="showAdjustments">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ getFundAdjustedBalance(dataItem) | currency }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="ExpType" field="expenseType" [width]="100"></kendo-grid-column>

        <kendo-grid-messages
          [pagerItemsPerPage]="'per page'"
          [pagerItems]="'funds'"
          [pagerOf]="'of'"
          [pagerPage]="''"
          >

        </kendo-grid-messages>
        <ng-template #pagerTemplate kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage" let-total="total" let-pageSize="pageSize">
          <div fxLayout="row" fxLayoutAlign="start center" style="width: 100%;">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes [pageSizes]="[5,10,15]" fxHide.xs="true"></kendo-pager-page-sizes>
            <div fxFlex></div>
            <div style="font-size: smaller">{{total}} funds</div>
          </div>
        </ng-template>
      </kendo-grid>
    </div>
    <kendo-dialog-actions *ngIf="this.windowMode == 'dialog'">
      <button kendoButton class="acb-cancel" (click)="onCancel()"><span class="k-icon k-i-cancel"></span>Cancel</button>
      <button kendoButton [primary]="true" [disabled]="!isSelected" (click)="onSelect(getSelectedItem())" ><span class="k-icon k-i-checkmark"></span>Select</button>
    </kendo-dialog-actions>
  `,
  styleUrls: ['./select-fund.component.scss']
})

export class SelectFundComponent extends SelectComponentBase<FundSearchWithDefaultModel> implements OnInit, OnDestroy, OnChanges {
  @Input() channel: string = '';
  @Input() formControlName: string = '';
  @Input() windowMode: WindowMode = 'dialog';
  @Input() fundAdjustments: FundAdjustment[] = [];
  @Input() showAdjustments: boolean = false;
  @Input() public set initialChannel(value: string | null | undefined) {
    console.log('initialChannel setter called with:', value);
    this._initialChannel = value;
    // If channels are already loaded, set it now
    if (value && this.channels.length > 0) {
      console.log('Setting selectedChannelName immediately to:', value);
      this.selectedChannelName = value;
    }
  }

  private _initialChannel: string | null | undefined;


  @ViewChild(FundSelectSearchBindingDirective) public set fundSelectSearchBinding(value:FundSelectSearchBindingDirective) {
    this.bindingDirective = value;
    this.rebind();  }

   public channelNameDropdownDisabledIndex = 0;
   public focusedRowIndex: number | null = null;
   public rowIndexSelected: number = -1;
   public dataItemSelected: object | null = null;
  
  
  public channelForDropdownSource$ = new BehaviorSubject<ChannelForDropdownModel[]>([]);
  
  //public defaultItem = { channelName: 'Select item...' };

  public selectedFundID: number = 0;

  gridData: any[] = [];
  public addToGrid(dataItem: FundSearchWithDefaultModel): void {
  if (dataItem?.channelName) {
    const alreadyExists = this.gridData.some(d => d.channelName === dataItem.channelName && d.fundID === dataItem.fundID);
    if (!alreadyExists) {
      this.gridData = [...this.gridData, dataItem];
      alert(`Added ${dataItem.channelName} for fund ID ${dataItem.fundID}`);
    } else {
      alert('Item already exists in grid');
    }
  } else {
    alert('No channel selected');
  }
  }

  public channels: Array<{ channelName: string }> = [{ channelName: 'A' }, { channelName: 'B' }, { channelName: 'C' }];
  public defaultItem = { channelName: 'Select item...' };


  public channelForDropdown$: Observable<ChannelForDropdownModel[]> = this.channelForDropdownSource$.asObservable();

  get isSelected():boolean {
    return Boolean(this._selectedChannel?.fundID);
  }

  private _bindingDirectiveDataChangeSubscription?: Subscription
  @Input() public set fundSpec(value: { fundID?:number | null | undefined, customerID:number | null | undefined, fundYears?: number[], doShowHidden?:boolean }) {

    this._bindingDirectiveDataChangeSubscription?.unsubscribe();
    if (!value) return;

    if (value.fundID)
      this.selectedKeys[0] = value.fundID;

    this.searchForm.patchValue({ prependFundID: value.fundID, customerID: value.customerID, fundYears: value.fundYears?.join(','), doShowHidden: value.doShowHidden });

    const data: FundSearchWithDefaultModel[] = (this.resultsGrid?.data as GridDataResult)?.data;
    let fund = value.fundID && data?.length ? data.find(x => x.fundID == value.fundID) : null;
         
    // make selection now if fund is naturally on first page
    if (fund) {
      this.doSelectionChange(fund);
    // else wait until data page is refreshed with prepend fund
    } else {
      this._bindingDirectiveDataChangeSubscription = this.bindingDirective?.dataChange.pipe(
        map((x:GridDataResult) => x?.data?.find((y:any) => y?.fundID == value.fundID) as FundSearchWithDefaultModel ?? null),
        filter(x => Boolean(x)),
        first()
      ).subscribe(x => this.doSelectionChange(x));
      super.onSearch();
    }
  }

  @HostListener('window:keyup.enter', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    event.stopPropagation();
  }

  protected formFieldsToClearOnSelect:string[] = ['prependFundID'];

  public _selectedChannel:FundSearchWithDefaultModel | null = null;
  public _hideChannelSelect: Boolean | null = null;
  public selectedChannelName: string = '';
  
  public destroy$: Subject<void> = new Subject<void>();

  public searchForm: UntypedFormGroup = new UntypedFormGroup({
    fundYears: new UntypedFormControl(),
    fundNameOrYear: new UntypedFormControl(),
    customerID: new UntypedFormControl(),
    prependFundID: new UntypedFormControl(),
    doShowHidden: new UntypedFormControl(),
    channelName: new UntypedFormControl()
  });

  private readonly _id = Math.random().toString(16).slice(2);

  constructor( 
    private store: Store,
    private configService: ConfigService,
    private channelForDropdownService: ChannelForDropdownService,
    @Optional() wizardFeatureService?: WizardFeatureService,
    @Optional() commitmentFormBaseService?: CommitmentFormBaseService
    ) {
    super(wizardFeatureService);

    console.log(`[SelectFund ${this._id}] ctor`);
    console.log(`[SelectFund ${this._id}] initial inputs snapshot`, {
      channel: this.channel,
      windowMode: this.windowMode,
      formControlName: this.formControlName
    });
  } 

    public onCheckboxChange(event: any, dataItem: any, rowIndex: number): void {
      const checked = event.target.checked;       
      const input = event.target as HTMLInputElement; 
      const disableEnableDropdown = `${input.checked}`;
      const row = rowIndex;
      //alert(`Rowxx ` + JSON.stringify(event) + ' rowindex - ' + rowIndex + ' dataItemxx - ' + JSON.stringify(dataItem));  
        if (row >= 0) {
         this.disableEnableDropdown = 'true';
        // alert('onCellclick - ' + JSON.stringify(event))
         this.onSelectionChange(event, dataItem, -1);
         this.isCategoryDisabled('true', rowIndex);
        //this.onSelectionChange(event?.selectedRows?.length ? event.selectedRows[0]?.dataItem : null, null, -1);
        this.resetDropdown(rowIndex); // reset dropdown when checkbox is cleared
      }
  } 

  public onCellClick(event: any): void {
        const row = event.rowIndex;
        //alert('onCellclick - ' + JSON.stringify(event))
    if (event.column.field === "displayName" || event.column.field === "year") {
        if (row >= 0) {
         this.disableEnableDropdown = 'true';
         this.isCategoryDisabled('true', event.rowIndex);
         
         this.onSelectionChange(event, null, -1);
        //this.onSelectionChange(event?.selectedRows?.length ? event.selectedRows[0]?.dataItem : null, null, -1);
        this.resetDropdown(event.rowIndex); // reset dropdown when checkbox is cleared
      }
    }
    this.focusedRowIndex = event.rowIndex;
  }

  public disableEnableDropdown:string = 'false';

  public resetDropdown(rowIndex: number): void {
        console.log('reset Dropdown here for index - ' + rowIndex)        
      };

  public isCategoryDisabled(isChannelChecked: string, rowIndex: number): number {
    isChannelChecked == 'false' ? this.channelNameDropdownDisabledIndex = -1 : this.channelNameDropdownDisabledIndex = rowIndex;
    //alert('ckBoxChg ' + this.channelNameDropdownDisabledIndex)
    this.defaultItem = { channelName: 'Select item...' };
    return this.channelNameDropdownDisabledIndex;
  }

  onThisSelectionChange(selectedKeys: any[]): void {
    this.selectedFundID = selectedKeys.length ? selectedKeys[0] : null;
  }

  public getSelectedItem():FundSearchWithDefaultModel | null {
    return this._selectedChannel;
  }
   

  public getFundAdjustment(fund: FundSearchWithDefaultModel): number {
    if (!this.fundAdjustments?.length)
      return 0;
    return this.fundAdjustments.find(x => x.fundID && x.fundID == fund.fundID)?.adjustmentAmount ?? 0;
  }

  public getFundAdjustedBalance(fund: FundSearchWithDefaultModel): number {
    const adjustment = this.fundAdjustments?.length ?
      (this.fundAdjustments.find(x => x.fundID && x.fundID == fund.fundID)?.adjustmentAmount ?? 0) : 0;
    return (fund.balance ?? 0) + adjustment;
  }

  public doSelectionChange(fund: FundSearchWithDefaultModel | null) {
    //alert('doSelChangexx - ')
    if (fund?.fundID) this.selectedKeys[0] = fund?.fundID;
    this._selectedChannel = fund;
    //alert('doSelChanging - ' + JSON.stringify(fund))
    this.searchForm.patchValue({ prependFundID: this._selectedChannel?.channelName ?? null });
    this.selectedChange.emit(this._selectedChannel);
  }
  
  @Output() channelChange = new EventEmitter<string>();

  public onGlobalChannelChange(channelName: string) {
    //console.log('Channel changed to:', channelName);
    //alert('Channel changed to: ' + channelName);

    this.selectedChannelName = channelName;

    this.channelChange.emit(channelName);

    const selectedItem = this.getSelectedItem();
    if (selectedItem) {
      selectedItem.channelName = channelName;
    }
  }

  @Output() selectFund = new EventEmitter<FundSearchWithDefaultModel>();

  ngOnChanges(changes: SimpleChanges) {
    console.log('SelectFund ngOnChanges', changes);
  }

  ngOnInit(): void {
    this._hideChannelSelect = this.configService.env == 'LENS' ? false : true;

    console.log(`[SelectFund ${this._id}] ngOnInit`, {
      initialChannel: this._initialChannel,
      selectedChannelName: this.selectedChannelName
    });

  this.channelForDropdownService
    .getChannelList()
    .pipe(first())
    .subscribe(list => {
      console.log('Channel list loaded:', list);
      this.channelForDropdownSource$.next(list);
      this.channelForDropdown$ = this.channelForDropdownSource$;
      this.channels = list
        .map(x => x.channelListName)
        .filter((n): n is string => !!n && n.trim().length > 0)
        .map(n => ({ channelName: n }));
      console.log('Channels array:', this.channels);
      console.log('_initialChannel value:', this._initialChannel);

      // After channels are loaded, set the initial channel if it was provided
      if (this._initialChannel && this.channels.length > 0) {
        console.log('Setting selectedChannelName to:', this._initialChannel);
        this.selectedChannelName = this._initialChannel;
        console.log('selectedChannelName is now:', this.selectedChannelName);
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @Output() fundSelected = new EventEmitter<FundSearchWithDefaultModel>();

}
